import { render, staticRenderFns } from "./authForm.vue?vue&type=template&id=48af90c0&scoped=true"
import script from "./authForm.vue?vue&type=script&lang=js"
export * from "./authForm.vue?vue&type=script&lang=js"
import style0 from "./authForm.vue?vue&type=style&index=0&id=48af90c0&prod&lang=scss&scoped=true"
import style1 from "./authForm.vue?vue&type=style&index=1&id=48af90c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48af90c0",
  null
  
)

export default component.exports